import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const AboutClg = () => {
  const [guidelines, setGuidelines] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("about_clg");
      setGuidelines(response.results); // Store the guidelines data
    };
    fetchData();
  }, []);

  if (!guidelines) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  console.log(guidelines[0].data); // For debugging

  // Function to render text with spans
  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0; // Keep track of the last index processed
    const elements = []; // Array to hold the JSX elements

    spans.forEach((span) => {
      // Push text before the current span
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      // Determine the span type and create the corresponding element
      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>
            {text.slice(span.start, span.end)}
          </strong>
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {text.slice(span.start, span.end)}
          </a>
        );
      }

      // Update lastIndex to the end of the current span
      lastIndex = span.end;
    });

    // Push any remaining text after the last span
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };
  return (
    <div className="my-4 py-4">
      <div class="join-our-events images-overlay bg8 sec-spacer">
        <div class="container">
          <div class="sec-title3 transparent text-center">
            <span>ABOUT THE COLLEGE</span>
            <h2>{guidelines[0].data?.title[0]?.text}</h2>
          </div>
          <div
            style={{ textAlign: "justify" }}
            class="row choose-list text-center text-white"
          >
            {guidelines[0].data?.description.map((para, index) => (
              <p
                key={index}
                className=""
                style={{
                  fontSize: guidelines[0].data?.description[0]?.fontSize,
                }}
              >
                {renderTextWithSpans(para.text, para.spans)}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutClg;
